import React from 'react'
import PageHeader from './PageHeader'
import Iqac1 from "../assets/IQAC Meeting 08.07.2025.pdf"
import Iqac2 from "../assets/IQAC Meeting 07.11.2025.pdf"

const Iqac_Meetings = () => {

    const tbody = [
        [1, "IQAC Meeting 08.07.2025", Iqac1],
        [2, "IQAC Meeting 07.11.2025", Iqac2]
    ]

    return (

        <>

            <PageHeader title="IQAC Meetings" />



            <div style={styles.container}>


                <div style={styles.tableWrapper}>
                    <table style={styles.table}>

                        <thead>
                            <tr>
                                {["S.No", "Meeting Name", "View PDF"].map((th, index) => (
                                    <th key={index} style={styles.th}>{th}</th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {tbody.map((row, rowIndex) => (
                                <tr key={rowIndex} style={styles.tr}>

                                    <td style={styles.td}>{row[0]}</td>

                                    <td style={styles.td}>{row[1]}</td>

                                    <td style={styles.td}>
                                        <a
                                            href={row[2]}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={styles.button}
                                        >
                                            View PDF
                                        </a>
                                    </td>

                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>

        </>
    )
}

const styles = {

    container: {
        padding: "20px",
        maxWidth: "1200px",  
        margin: "0 auto",    
    },

    tableWrapper: {
        overflowX: "auto", 
        background: "#fff",
      
      
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",
        minWidth: "500px",
    },

    th: {
        padding: "12px",
        background: "#1e293b",
        color: "#fff",
        textAlign: "left",
        fontSize: "14px",
    },

    td: {
        padding: "12px",
        borderBottom: "1px solid #e5e7eb",
        fontSize: "14px",
    },

    tr: {
        transition: "0.2s",
    },

    button: {
        background: "#ef4444",
        color: "#fff",
        padding: "6px 12px",
        borderRadius: "6px",
        textDecoration: "none",
        fontSize: "13px",
        fontWeight: "500",
    }

}

export default Iqac_Meetings